export const pictureSizeToCounterSizeDict = {
    "16": "",
    "20": "",
    "24": "8",
    "36": "12",
    "44": "16",
    "56": "16",
    "72": "20",
    "96": "24",
} as const;

export const pictureSizeToBadgeSizeDict = {
    "16": "",
    "20": "",
    "24": "",
    "36": "12",
    "44": "16",
    "56": "16",
    "72": "20",
    "96": "24",
} as const;

export const badgeSizeToPictureSizeDict = {
    "12": "36",
    "16": ["44", "56"],
    "20": "72",
    "24": "96",
};

export const pictureSizeToIconSizeDict = {
    "16": "12",
    "20": "12",
    "24": "16",
    "36": "20",
    "44": "24",
    "56": "24",
    "72": "32",
    "96": "48",
} as const;

export const iconSizeToPictureSizeDict = {
    "12": ["16", "20"],
    "16": "24",
    "20": "36",
    "24": ["44", "56"],
    "32": "72",
    "48": "96",
};
